import { Monitor, Smartphone, Tablet } from 'lucide-react'

import type { Viewport } from './types'

interface Props {
  value: Viewport
  onChange: (v: Viewport) => void
}

const OPTIONS: Array<{ key: Viewport; label: string; Icon: typeof Monitor; width: number }> = [
  { key: 'desktop', label: 'Desktop', Icon: Monitor,     width: 1280 },
  { key: 'tablet',  label: 'Tablet',  Icon: Tablet,      width: 768 },
  { key: 'mobile',  label: 'Mobile',  Icon: Smartphone,  width: 390 },
]

export function DeviceToggle({ value, onChange }: Props) {
  return (
    <div
      role="group"
      aria-label="Preview device"
      style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}
    >
      {OPTIONS.map(({ key, label, Icon }) => (
        <button
          key={key}
          type="button"
          aria-pressed={value === key}
          title={label}
          onClick={() => onChange(key)}
          style={{
            padding: '3px 6px',
            border: 'none',
            borderRadius: 4,
            cursor: 'pointer',
            background: value === key ? 'var(--color-accent-weak)' : 'transparent',
            color: value === key ? 'var(--color-accent)' : 'var(--color-text-secondary)',
            display: 'inline-flex',
            alignItems: 'center',
          }}
        >
          <Icon size={16} />
        </button>
      ))}
    </div>
  )
}

export function viewportWidth(v: Viewport): number {
  return OPTIONS.find(o => o.key === v)?.width ?? 1280
}
